// Shared badge style maps for Order status and payment status.
// Keys mirror Order::ORDER_STATUS and Order::PAYMENT_STATUS (app/models/order.rb),
// so every valid enum value gets a distinct badge color across the admin portal.

export const ORDER_STATUS_STYLES: Record<string, string> = {
	DRAFT: "bg-slate-100 text-slate-600 border-slate-200 hover:bg-slate-100/80",
	PENDING_PAYMENT:
		"bg-amber-100 text-amber-700 border-amber-200 hover:bg-amber-100/80",
	PARTIALLY_PAID:
		"bg-amber-100 text-amber-700 border-amber-200 hover:bg-amber-100/80",
	PAID: "bg-emerald-100 text-emerald-700 border-emerald-200 hover:bg-emerald-100/80",
	SCHEDULED: "bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100/80",
	IN_PROGRESS:
		"bg-indigo-100 text-indigo-700 border-indigo-200 hover:bg-indigo-100/80",
	COMPLETED:
		"bg-emerald-100 text-emerald-700 border-emerald-200 hover:bg-emerald-100/80",
	PARTIALLY_COMPLETED:
		"bg-teal-100 text-teal-700 border-teal-200 hover:bg-teal-100/80",
	CANCELLED: "bg-red-100 text-red-700 border-red-200 hover:bg-red-100/80",
	REFUNDED:
		"bg-slate-100 text-slate-700 border-slate-200 hover:bg-slate-100/80",
};

// The Orders list's status filter, which also mirrors Order::ORDER_STATUS.
export const ORDER_STATUS_OPTIONS = [
	{ value: "all", label: "All Order Status" },
	{ value: "DRAFT", label: "Draft" },
	{ value: "PENDING_PAYMENT", label: "Pending Payment" },
	{ value: "PARTIALLY_PAID", label: "Partially Paid" },
	{ value: "PAID", label: "Paid" },
	{ value: "SCHEDULED", label: "Scheduled" },
	{ value: "IN_PROGRESS", label: "In Progress" },
	{ value: "COMPLETED", label: "Completed" },
	{ value: "PARTIALLY_COMPLETED", label: "Partially Completed" },
	{ value: "CANCELLED", label: "Cancelled" },
	{ value: "REFUNDED", label: "Refunded" },
];

export const PAYMENT_STATUS_STYLES: Record<string, string> = {
	UNPAID: "bg-red-100 text-red-700 border-red-200 hover:bg-red-100/80",
	PARTIALLY_PAID:
		"bg-amber-100 text-amber-700 border-amber-200 hover:bg-amber-100/80",
	PAID: "bg-emerald-100 text-emerald-700 border-emerald-200 hover:bg-emerald-100/80",
	OVERPAID: "bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100/80",
	REFUNDED:
		"bg-slate-100 text-slate-700 border-slate-200 hover:bg-slate-100/80",
};

export const FALLBACK_STATUS_STYLE = "bg-background hover:bg-background/80";

export function orderStatusStyle(status: string | null | undefined) {
	return (status && ORDER_STATUS_STYLES[status]) || FALLBACK_STATUS_STYLE;
}

export function paymentStatusStyle(status: string | null | undefined) {
	return (status && PAYMENT_STATUS_STYLES[status]) || FALLBACK_STATUS_STYLE;
}
